import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';

type Variables = {
  id: number;
  credits: number;
};
export type UseCreditResponse = {
  data: {
    oldAmount: number;
    newAmount: number;
  };
};

export const useCredits = createMutation<
  UseCreditResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/use-credits`,
      method: 'PUT',
      data: {
        credits: variables.credits,
      },
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
